<template>
  <div class="CategoryMaintananceAdd">
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="80%"
      :before-close="handleClose"
      center
      custom-class="CategoryMaintananceAddDIalog"
    >
      <span slot="title" class="dialog-title">{{ dialogTitle }}</span>
      <div class="form">
        <el-form
          ref="form"
          :model="form"
          label-width="150px"
          class="clearfix"
          label-position="right"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item
                label="Category Name:"
                :rules="[{ required: true, message: 'require' }]"
                prop="CategoryName"
              >
                <el-input
                  placeholder="Please enter content"
                  v-model="form.CategoryName"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="Calculation Mode:"
                prop="CalculationMode"
                :rules="[{ required: true, message: 'require' }]"
              >
                <el-select
                  v-model="form.CalculationMode"
                  clearable
                  placeholder="Please Choose"
                  style="margin-left: 10px"
                >
                  <el-option
                    v-for="item in CalculationModes"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="X-PEX:"
                prop="XPEX"
                :rules="[{ required: true, message: 'require' }]"
              >
                <el-select
                  v-model="form.XPEX"
                  clearable
                  placeholder="Please Choose"
                  style="margin-left: 10px"
                >
                  <el-option
                    v-for="item in XPEXS"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item
                label="Sub X-PEX:"
                prop="Sub_XPEX"
                :rules="[{ required: true, message: 'require' }]"
              >
                <el-select
                  v-model="form.Sub_XPEX"
                  clearable
                  placeholder="Please Choose"
                  style="margin-left: 10px"
                >
                  <el-option
                    v-for="item in SubXPEXS"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="Supporting Scheme:"
                prop="SupportingScheme"
                :rules="[{ required: true, message: 'require' }]"
              >
                <el-checkbox-group
                  v-model="form.SupportingScheme"
                  class="supporting-check"
                >
                  <template>
                    <el-checkbox
                      :label="item"
                      name="type"
                      v-for="item in Supporting"
                      :key="item"
                    ></el-checkbox>
                  </template>
                </el-checkbox-group>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="VAT Rate:"
                prop="VATRate"
                :rules="[{ required: true, message: 'require' }]"
              >
                <el-select
                  v-model="form.VATRate"
                  clearable
                  placeholder="Please Choose"
                  style="margin-left: 10px"
                >
                  <el-option
                    v-for="item in varRates"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="Sort:"
                prop="Sort"
                :rules="[{ required: true, message: 'require' }]"
              >
                <el-select
                  v-model="form.Sort"
                  clearable
                  placeholder="Please Choose"
                  style="margin-left: 10px"
                >
                  <el-option
                    v-for="item in Sorts"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="Category Names"
                prop="ExitCategoryName"
                :rules="
                  CategoryNames.length > 0
                    ? [{ required: true, message: 'require' }]
                    : []
                "
              >
                <el-select
                  v-model="form.ExitCategoryName"
                  clearable
                  placeholder="Please Choose"
                  style="margin-left: 10px"
                >
                  <el-option
                    v-for="item in CategoryNames"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="button-search" @click="submitForm('form')"
          >Save</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      dialogTitle: "Category Maintanance",
      CalculationModes: ["POS", "Space"],
      XPEXS: ["Capex", "Opex"],
      SubXPEXS: ["Capex", "Opex", "Digital"],
      Sorts: ["Before", "After"],
      CategoryNames: [],
      StatusList: ["Active", "Inactive"],
      Supporting: ["D", "A", "F", "X"],
      varRates: [],
      form: {
        CategoryName: "",
        CalculationMode: "",
        XPEX: "",
        Sub_XPEX: "",
        SupportingScheme: [],
        sort: "",
        CategoryName: "",
        Status: "",
        ExitCategoryName: "",
        VATRate: "",
      },
    };
  },
  watch: {},
  methods: {
    handleClose(done) {
      this.$emit("closeDialog");
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$emit("closeDialog", this.form);
          return false;
        }
      });
      this.$api.post("/CR/SaveCategory", this.form).then((res) => {
        if (res.data.status) {
          this.getCategoryNames();
          this.$message({
            type: "success",
            message: "Save Success",
          });
          this.$parent.BindData();
        } else {
          this.$message({
            type: "error",
            message: res.data.message,
          });
          return false;
        }
      });
    },
    getCategoryNames() {
      this.$api.get("/CR/GetCategoryName", {}).then((res) => {
        if (res.data.status) {
          this.CategoryNames = res.data.content;
        } else {
          this.$message({
            type: "error",
            message: res.data.message,
          });
          return false;
        }
      });
    },
    getGetVatRate() {
      this.$api.get("/CR/GetVATRATE", {}).then((res) => {
        if (res.data.status) {
          this.varRates = res.data.content;
        } else {
          this.$message({
            type: "error",
            message: res.data.message,
          });
          return false;
        }
      });
    },
  },
  created() {
    this.getCategoryNames();
    this.getGetVatRate();
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.clearfix:after {
  content: "";
  height: 0;
  line-height: 0;
  display: block;
  visibility: hidden;
  clear: both;
}
.clearfix {
  zoom: 1;
}
.button-search {
  background-color: #e6a23c;
  border: 0px #e6a23c;
  color: #ffff;
}
.dialog-footer {
  text-align: center;
}
</style>
<style lang="scss">
.CategoryMaintananceAddDIalog {
  .el-form-item__label {
    font-size: 13px;
  }
  .el-dialog__header {
    text-align: left;
  }
  .supporting-check {
    display: flex;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/CategoryMaintananceAddDialog.vue